import React from "react";

const HeaderHighlight = ({highlightText}: any) => {
    return (
        <div className="relative z-[99] min-w-[447px] max-w-fit mx-auto">
            <div className="absolute top-0 w-full z-0 text-center">
                <div className="bg-[#F33D62] min-h-[44px] inline-block rounded-b-lg p-4 pb-[10px]">
                    <p className="text-white text-sm font-bold leading-[1.3125]">{highlightText}</p>
                </div>            
            </div>
        </div>
    );
}
export default HeaderHighlight;